/**
 * AUTO-GENERATED - do not edit by hand.
 *
 * Generated by scripts/export-manufacturer-verified.mjs from
 * public.manufacturer_verifications rows with review_status='applied'
 * (the founder-side gate of the /verify manufacturer panels).
 *
 * Only verdicts that still PIN to the current catalog are exported:
 * a 'confirmed' verdict must have its baseline snapshot equal to the
 * catalog's current values, a 'corrected' verdict must have its
 * corrections equal to them. If the catalog moved since the review,
 * the entry is skipped until the model is re-verified, so the badge
 * never blesses values the manufacturer did not actually see.
 *
 * Stats: 0 verified models across 0 brands.
 *
 * To update: SUPABASE_URL=... SUPABASE_SERVICE_ROLE_KEY=... \
 *   npx tsx scripts/export-manufacturer-verified.mjs
 */

export interface ManufacturerVerifiedEntry {
  /** Brand display name exactly as the catalog spells it. */
  brand: string;
  /** ISO date of the newest applied verdict for this model. */
  verifiedAt: string;
}

/** Keyed by `${brandSlug}|${modelName}` (generateBrandSlug rules). */
export const MANUFACTURER_VERIFIED: Readonly<Record<string, ManufacturerVerifiedEntry>> = {};
